export const REQUEST_CONSTANTS = {
    SELECT_REASON_TYPE: "Select Reason Type"
}